import * as Forms from "../forms";
import { FormFieldInputs } from "../../components/input/Input";

export interface FormFields extends Forms.FormFields {
    marketingEmailStatus: string;
    pushNotifications: string;
}

export const formFieldInputs: FormFieldInputs = {
    marketingEmailStatus: {
        name: "marketingEmailStatus",
        label: "Newsletters & Marketing Emails",
        type: "select",
        options: [
            { text: 'Subscribed', key: '1' },
            { text: 'Unsubscribed', key: '2' },
        ]
    },
    pushNotifications: {
        name: "pushNotifications",
        label: "Device Notifications",
        type: "select",
        options: [
            { text: 'Subscribed', key: '1' },
            { text: 'Unsubscribed', key: '2' },
        ]
    },
};

export interface Form extends Forms.Form {
    fields: FormFields;
}

export const initialState: Form = {
    ...Forms.formInitialState,
    fields: {
        marketingEmailStatus: "",
        pushNotifications: '1',
    },
};

export const formName = "preferences";
